import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { Input, TimePicker } from "uxp/components";
import { Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";

interface ITimeFieldProperty extends IBaseInputFieldProperty {
	title?: string
	label:string
	fieldLabel:IFieldTitleProps,
}

export const Field: React.FunctionComponent<IUIFieldProps<ITimeFieldProperty>> = (props) => {
	let { value, onChange, title,label } = props?.fieldProps || {};

	let styles: React.CSSProperties = {}

	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {} } />

			<TimePicker
				title={title || 'Date'}
				time={value || new Date()}
				onChange={onChange}
			/>
		</div>
	)
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ITimeFieldProperty>> = (props) => {

	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Time Input</PropertyGroupTitle>

			<Property>
				<PropertyTitle>Value</PropertyTitle>
				<TimePicker
					title="Time"
					time={props.uiProps.value || new Date()}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { value: s }))}
					hideLabels
				/>
			</Property>

			<Property>
				<PropertyTitle>Title</PropertyTitle>
				<Input
					value={props.uiProps.title || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { title: s }))}
					className="widget-designer-input"
				/>
			</Property>
			<Property>
				<PropertyTitle>Label</PropertyTitle>
				<Input
					value={props.uiProps.label || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { label: s }))}
					className="widget-designer-input"
				/>
			</Property>

		</PropertyGroup>
		<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
	</PropertyContainer>;
}

registerUIField({
	id: 'time',
	category: 'date-time',
	description: 'Time Input',
	field: Field,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		title: 'Time',
		label:'Pick a time',
		fieldLabel:{
			label:'Pick a time',
		},
	},
	type:'time'

});
